import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
const STORAGE_KEY = "sample_at_home_popup_dismissed";
const SampleAtHomePopup: React.FC = () => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const isDismissed = typeof window !== "undefined" && window.localStorage
            ? window.localStorage.getItem(STORAGE_KEY) === "true"
            : false;
        if (!isDismissed) {
            const timer = setTimeout(() => {
                setOpen(true);
            }, 3500);
            return () => clearTimeout(timer);
        }
    }, []);
    const handleClose = () => {
        if (typeof window !== "undefined" && window.localStorage) {
            window.localStorage.setItem(STORAGE_KEY, "true");
        }
        setOpen(false);
    };
    if (!open)
        return null;
    return (<div className="fixed bottom-4 right-4 left-4 md:left-auto md:max-w-sm z-40">
      <div className="relative overflow-hidden rounded-2xl border border-border bg-background/95 shadow-xl backdrop-blur-sm">
        <button type="button" onClick={handleClose} aria-label="بستن" className="absolute left-3 top-3 inline-flex h-7 w-7 items-center justify-center rounded-full bg-background/80 text-muted-foreground shadow-sm transition hover:bg-muted hover:text-foreground">
          <X className="h-4 w-4"/>
        </button>

        <div className="flex flex-col gap-3 p-4 pr-5 pl-12 md:p-5 md:pl-14">
          <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
            نمونه‌گیری رایگان در محل
          </span>

          <div className="space-y-1.5 text-right">
            <h3 className="text-base font-semibold leading-snug md:text-lg">
              بدون خروج از خانه، آزمایش بدهید
            </h3>
            <p className="text-xs text-muted-foreground md:text-sm leading-relaxed">
              تیم نمونه‌گیری ما به صورت رایگان به آدرس شما می‌آید و تمام مراحل
              آزمایش را با رعایت کامل اصول بهداشتی انجام می‌دهد.
            </p>
          </div>

          <div className="mt-1 flex flex-col items-stretch gap-2 md:flex-row-reverse md:items-center">
            <Button size="sm" className="w-full md:w-auto" asChild>
              <Link to="/sample-at-home" onClick={handleClose}>
                اطلاعات بیشتر و ثبت درخواست
              </Link>
            </Button>
            <button type="button" onClick={handleClose} className="text-xs text-muted-foreground underline-offset-4 hover:underline md:text-sm text-right md:text-left">
              بعداً یادآوری کن
            </button>
          </div>
        </div>
      </div>
    </div>);
};
export default SampleAtHomePopup;
